import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { delay: { type: Number, default: 0 } }

  connect() {
    this._timer = null
  }

  submit() {
    if (this.delayValue > 0) {
      clearTimeout(this._timer)
      this._timer = setTimeout(() => this.element.requestSubmit(), this.delayValue)
    } else {
      this.element.requestSubmit()
    }
  }

  disconnect() {
    clearTimeout(this._timer)
  }
}
